import "./index.scss";

const Location = () => {


    return (
        <div className="container-location">
            <h2>Nos localize nesse endereço</h2>
        <iframe
            title="Mapa fictício"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.370823084794!2d-46.6617789849806!3d-23.588068984669424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce59cbd0a67657%3A0x8f63a5e2df4f7d51!2sAv.%20Paulista!5e0!3m2!1spt-BR!2sbr!4v1637863070000!5m2!1spt-BR!2sbr"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
      ></iframe>
        </div>
    )
}

export default Location;